"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.businessDaysLaterCanBeBookedFilter = void 0;
const date_fns_1 = require("date-fns");
const __1 = require("../..");
const calcBusinessDaysLater_1 = require("./calcBusinessDaysLater");
/**
 * 最短何日後から予約可能かのフィルター
 * NOTE: 現状タイムゾーンは考慮していない。
 * またこの辺り対応する時にまとめてやる
 * https://www.notion.so/0f8674b87313462a9aa6c2cf8c39a43c
 * @param periods
 * @param daysLaterCanBeBooked
 * @returns
 */
const businessDaysLaterCanBeBookedFilter = (periods, daysLaterCanBeBooked, availabilities, nationalHolidays) => {
    const startDate = (0, calcBusinessDaysLater_1.calcBusinessDaysLater)(daysLaterCanBeBooked.start, availabilities, nationalHolidays);
    const endDate = (0, calcBusinessDaysLater_1.calcBusinessDaysLater)(daysLaterCanBeBooked.end, availabilities, nationalHolidays);
    const bookablePeriods = new __1.Periods([
        new __1.Period(startDate, (0, date_fns_1.endOfDay)(endDate))
    ]);
    // フィルター
    return periods.and(bookablePeriods);
};
exports.businessDaysLaterCanBeBookedFilter = businessDaysLaterCanBeBookedFilter;
//# sourceMappingURL=businessDaysLatereCanBeBookedFilter.js.map